import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import Footer from '../components/Footer';

const Datenschutz = () => {
  return (
    <div className="bg-charcoal min-h-screen text-zinc-100">
      <div className="max-w-3xl mx-auto px-6 pt-24 pb-16">
        <Link
          to="/"
          className="inline-flex items-center gap-2 text-yellow hover:underline mb-10 font-medium"
        >
          <ArrowLeft className="w-4 h-4" /> Zurück zur Startseite
        </Link>

        <h1 className="font-display text-yellow text-4xl md:text-5xl mb-10">
          Datenschutzerklärung
        </h1>

        <section className="space-y-8 leading-relaxed text-zinc-200">
          <div>
            <h2 className="font-heavy text-yellow text-xl mb-2">1. Allgemeines</h2>
            <p>
              Der Schutz deiner persönlichen Daten ist uns ein wichtiges Anliegen. Diese
              Datenschutzerklärung informiert dich darüber, welche personenbezogenen Daten beim
              Besuch dieser Website verarbeitet werden und wie wir mit ihnen umgehen. Grundlage
              dafür ist die Datenschutz-Grundverordnung (DSGVO) sowie das Bundesdatenschutzgesetz
              (BDSG).
            </p>
          </div>

          <div>
            <h2 className="font-heavy text-yellow text-xl mb-2">
              2. Verantwortlicher
            </h2>
            <p>
              Verantwortlich im Sinne der DSGVO ist:<br /><br />
              Till Sommer<br />
              Armsener Straße 5<br />
              28325 Bremen<br />
              Deutschland<br /><br />
              Telefon: <a href="tel:+4915229816526" className="hover:text-yellow underline-offset-4 hover:underline">015229816526</a><br />
              E-Mail: <a href="mailto:info.llit.media@gmail.com" className="hover:text-yellow underline-offset-4 hover:underline">info.llit.media@gmail.com</a>
            </p>
          </div>

          <div>
            <h2 className="font-heavy text-yellow text-xl mb-2">3. Hosting & Server-Logfiles</h2>
            <p>
              Diese Website wird bei einem externen Dienstleister (Hoster) gehostet. Der Hoster
              verarbeitet beim Aufruf der Website folgende Daten in sogenannten Server-Logfiles,
              die dein Browser automatisch übermittelt:
            </p>
            <ul className="list-disc list-inside mt-3 space-y-1 text-zinc-300">
              <li>IP-Adresse (anonymisiert)</li>
              <li>Datum und Uhrzeit des Zugriffs</li>
              <li>Browsertyp und -version</li>
              <li>Betriebssystem</li>
              <li>Referrer URL</li>
              <li>aufgerufene Seite</li>
            </ul>
            <p className="mt-3">
              Die Verarbeitung erfolgt zur Gewährleistung eines sicheren Betriebs, zur
              Fehleranalyse und zur Optimierung des Angebots. Rechtsgrundlage ist Art. 6 Abs. 1
              lit. f DSGVO (berechtigtes Interesse). Die Logfiles werden nach maximal 14 Tagen
              automatisch gelöscht.
            </p>
          </div>

          <div>
            <h2 className="font-heavy text-yellow text-xl mb-2">4. Kontaktaufnahme</h2>
            <p>
              Auf dieser Website besteht die Möglichkeit, über das Kontaktformular oder per
              direktem E-Mail-Klick Kontakt aufzunehmen. Wenn du das Kontaktformular nutzt,
              werden die von dir eingegebenen Daten (Vorname, Name, E-Mail-Adresse, gewählter
              Service sowie optionaler Nachrichtentext) übertragen, um deine Anfrage zu
              bearbeiten. Rechtsgrundlage ist Art. 6 Abs. 1 lit. b DSGVO (vertragliche
              Anbahnung) bzw. Art. 6 Abs. 1 lit. f DSGVO (berechtigtes Interesse an
              effektiver Beantwortung).
            </p>
            <p className="mt-3">
              Zur technischen Weiterleitung des Formulars an unser E-Mail-Postfach setzen wir
              den Dienst <strong>Formsubmit</strong> (formsubmit.co) ein. Formsubmit ist ein
              kostenloser Formular-Weiterleitungsdienst und verarbeitet deine Daten
              ausschließlich zum Zweck der einmaligen Zustellung deiner Nachricht an uns.
              Es werden keine Daten dauerhaft bei Formsubmit gespeichert. Da der Anbieter
              seinen Sitz außerhalb der EU haben kann, weisen wir darauf hin, dass eine
              Übermittlung an ein Drittland stattfinden kann. Rechtsgrundlage ist Art. 6
              Abs. 1 lit. f DSGVO (berechtigtes Interesse an einer funktionierenden
              Kontaktmöglichkeit).
            </p>
            <p className="mt-3">
              Deine Angaben werden bei uns im E-Mail-Postfach gespeichert und ausschließlich
              zur Bearbeitung deiner Anfrage sowie für den Fall von Anschlussfragen verwendet.
              Eine Weitergabe an weitere Dritte erfolgt nicht. Die Daten werden gelöscht,
              sobald sie für den Zweck der Verarbeitung nicht mehr erforderlich sind,
              spätestens nach Ablauf gesetzlicher Aufbewahrungsfristen.
            </p>
          </div>

          <div>
            <h2 className="font-heavy text-yellow text-xl mb-2">
              5. Cookies & Tracking
            </h2>
            <p>
              Diese Website setzt <strong>keine</strong> Cookies zu Tracking- oder Marketingzwecken
              ein und nutzt <strong>keine</strong> Analyse-Tools (z.&nbsp;B. Google Analytics,
              Facebook Pixel o.&nbsp;ä.). Schriftarten werden ausschließlich lokal vom Server
              ausgeliefert; es findet keine Verbindung zu Google Fonts oder vergleichbaren
              CDN-Diensten statt.
            </p>
          </div>

          <div>
            <h2 className="font-heavy text-yellow text-xl mb-2">7. SSL-Verschlüsselung</h2>
            <p>
              Diese Website nutzt aus Gründen der Sicherheit und zum Schutz der Übertragung
              vertraulicher Inhalte eine SSL-/TLS-Verschlüsselung. Du erkennst eine
              verschlüsselte Verbindung an dem Schloss-Symbol in der Adresszeile deines Browsers
              und am Präfix &bdquo;https://&ldquo;.
            </p>
          </div>

          <div>
            <h2 className="font-heavy text-yellow text-xl mb-2">
              8. Deine Rechte als betroffene Person
            </h2>
            <p>
              Du hast jederzeit das Recht auf:
            </p>
            <ul className="list-disc list-inside mt-3 space-y-1 text-zinc-300">
              <li>Auskunft über die zu deiner Person gespeicherten Daten (Art. 15 DSGVO)</li>
              <li>Berichtigung unrichtiger Daten (Art. 16 DSGVO)</li>
              <li>Löschung deiner Daten (Art. 17 DSGVO)</li>
              <li>Einschränkung der Verarbeitung (Art. 18 DSGVO)</li>
              <li>Datenübertragbarkeit (Art. 20 DSGVO)</li>
              <li>Widerspruch gegen die Verarbeitung (Art. 21 DSGVO)</li>
            </ul>
            <p className="mt-3">
              Zur Ausübung dieser Rechte genügt eine formlose E-Mail an{' '}
              <a href="mailto:info.llit.media@gmail.com" className="text-yellow underline-offset-4 hover:underline">
                info.llit.media@gmail.com
              </a>.
            </p>
          </div>

          <div>
            <h2 className="font-heavy text-yellow text-xl mb-2">
              9. Beschwerderecht bei der Aufsichtsbehörde
            </h2>
            <p>
              Du hast das Recht, dich bei einer Datenschutz-Aufsichtsbehörde über die
              Verarbeitung deiner personenbezogenen Daten durch uns zu beschweren. Zuständig ist
              die Landesbeauftragte für Datenschutz und Informationsfreiheit der Freien
              Hansestadt Bremen, Arndtstraße 1, 27570 Bremerhaven.
            </p>
          </div>

          <div>
            <h2 className="font-heavy text-yellow text-xl mb-2">10. Änderungen</h2>
            <p>
              Wir behalten uns vor, diese Datenschutzerklärung anzupassen, damit sie stets den
              aktuellen rechtlichen Anforderungen entspricht. Es gilt jeweils die Fassung beim
              Aufruf der Website.
            </p>
            <p className="mt-3 text-zinc-400 text-sm">
              Stand: {new Date().toLocaleDateString('de-DE', { month: 'long', year: 'numeric' })}
            </p>
          </div>
        </section>
      </div>

      <Footer />
    </div>
  );
};

export default Datenschutz;
